import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export enum ExecutionStatus {
    PENDING = 'PENDING',
    RUNNING = 'RUNNING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
    TIMED_OUT = 'TIMED_OUT',
}

export enum PhaseStatus {
    PENDING = 'PENDING',
    RUNNING = 'RUNNING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    SKIPPED = 'SKIPPED',
}

export enum StepStatus {
    PENDING = 'PENDING',
    RUNNING = 'RUNNING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    SKIPPED = 'SKIPPED',
    RETRYING = 'RETRYING',
}

export type ExecutionStep = {
    id: string,
    executionId?: string,
    executionPhaseId?: string,
    stepId?: string,
    phaseId?: string,
    stepName?: string,
    taskStateName?: string,
    position?: number,
    stepStatus?: StepStatus,
    startedAt?: string,
    completedAt?: string,
    elapsedMs?: number,
    input?: string,
    output?: string,
    errorMessage?: string,
    errorType?: string,
    retryCount?: number,
    created?: string,
    updated?: string,
}

export type ExecutionPhase = {
    id: string,
    executionId?: string,
    phaseId?: string,
    phaseName?: string,
    position?: number,
    phaseStatus?: PhaseStatus,
    startedAt?: string,
    completedAt?: string,
    steps?: ExecutionStep[],
    created?: string,
    updated?: string,
}

export type ExecutionPlaybookSummary = {
    id: string,
    name?: string,
    displayName?: string,
}

export type Execution = {
    id: string,
    playbookId?: string,
    playbook?: ExecutionPlaybookSummary,
    name?: string,
    description?: string,
    executionStatus?: ExecutionStatus,
    sfnExecutionArn?: string,
    executionInput?: string,
    executionOutput?: string,
    currentPhase?: string,
    totalPhases?: number,
    completedPhases?: number,
    startedAt?: string,
    completedAt?: string,
    failedStepId?: string,
    failedStepName?: string,
    failureReason?: string,
    phases?: ExecutionPhase[],
    createdByUsername?: string,
    created?: string,
    updated?: string,
}

export interface IExecutionTableColumn extends ITableColumn {
    render?: (item: Execution) => ReactNode;
}

export type ListExecutions = {
    listExecutions: { items: Execution[], nextToken?: string | null }
}

export type GetExecution = {
    getExecution: Execution
}

export type ExecutePlaybookInput = {
    playbookId: string,
    name: string,
    executionInput: string,
    description?: string,
}

export type ExecutePlaybook = {
    executePlaybook: Execution
}

export type CancelExecutionInput = {
    id: string,
    reason?: string,
}

export type CancelExecution = {
    cancelExecution: Execution
}

export type OnUpdateExecutionSubscription = {
    onUpdateExecution: Execution
}

export type OnUpdateExecutionPhaseSubscription = {
    onUpdateExecutionPhase: ExecutionPhase
}

export type OnUpdateExecutionStepSubscription = {
    onUpdateExecutionStep: ExecutionStep
}
